module.exports = __webpack_public_path__ + "img/clouds.b79a0d77.svg";